import { Model, type ModelProps } from '@/infra/model'
import { observable } from 'mobx'
import { unixEpoch } from '@/utils/date-util'
import { Id } from '@/infra/id'

export type TermsOfUseAcceptanceProps = ModelProps<TermsOfUseAcceptance>

export class TermsOfUseAcceptance extends Model<TermsOfUseAcceptance> {
  @observable accessor acceptedAt: Date = unixEpoch()
  @observable accessor termsOfUseId = Id.none
  @observable accessor workspaceId: Id | null = null
  @observable accessor internalUserId = Id.none
}
